import { IsObject } from '../../../helpers';
import { NOTIFICATIONS_OBSERVER_PRIVATE } from './privates';
export function IsNotificationsObserverLike(value) {
    return IsObject(value)
        && (typeof value.name === 'string')
        && (typeof value.callback === 'function');
}
export function ExtractObserverNameAndCallback(value) {
    if (!IsObject(value)) {
        return null;
    }
    else if (value.hasOwnProperty(NOTIFICATIONS_OBSERVER_PRIVATE)) {
        return value[NOTIFICATIONS_OBSERVER_PRIVATE];
    }
    else if ((typeof value.name === 'string')
        && (typeof value.callback === 'function')) {
        return value;
    }
    else {
        return null;
    }
}
//# sourceMappingURL=functions.js.map